
/* SCHOOLS */
export const GET_SCHOOLS_LISTING = "GET_SCHOOLS_LISTING";
export const GET_SCHOOLS_LISTING_SUCCESS = "GET_SCHOOLS_LISTING_SUCCESS";
export const GET_SCHOOLS_LISTING_FAIL = "GET_SCHOOLS_LISTING_FAIL";

export const GET_SCHOOLS_DETAILS = "GET_SCHOOLS_DETAILS";
export const GET_SCHOOLS_DETAILS_SUCCESS = "GET_SCHOOLS_DETAILS_SUCCESS";
export const GET_SCHOOLS_DETAILS_FAIL = "GET_SCHOOLS_DETAILS_FAIL";

export const ADD_SCHOOLS = "ADD_SCHOOLS";
export const ADD_SCHOOLS_SUCCESS = "ADD_SCHOOLS_SUCCESS";
export const ADD_SCHOOLS_FAIL = "ADD_SCHOOLS_FAIL";

export const UPDATE_SCHOOLS = "UPDATE_SCHOOLS";
export const UPDATE_SCHOOLS_SUCCESS = "UPDATE_SCHOOLS_SUCCESS";
export const UPDATE_SCHOOLS_FAIL = "UPDATE_SCHOOLS_FAIL";

export const DELETE_SCHOOLS = "DELETE_SCHOOLS";
export const DELETE_SCHOOLS_SUCCESS = "DELETE_SCHOOLS_SUCCESS";
export const DELETE_SCHOOLS_FAIL = "DELETE_SCHOOLS_FAIL";

export const BULK_DELETE_SCHOOLS = "BULK_DELETE_SCHOOLS";
export const BULK_DELETE_SCHOOLS_SUCCESS = "BULK_DELETE_SCHOOLS_SUCCESS";
export const BULK_DELETE_SCHOOLS_FAIL = "BULK_DELETE_SCHOOLS_FAIL";

export const EXPORT_SCHOOLS = "EXPORT_SCHOOLS";
export const EXPORT_SCHOOLS_SUCCESS = "EXPORT_SCHOOLS_SUCCESS";
export const EXPORT_SCHOOLS_FAIL = "EXPORT_SCHOOLS_FAIL";

export const RESET_SCHOOLS_STATE = 'RESET_SCHOOLS_STATE';
export const RESET_SCHOOLS_ATTACHMENT_STATE = 'RESET_SCHOOLS_ATTACHMENT_STATE';